import { X } from 'lucide-react';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  resultsCount?: number;
}

export function SearchBar({ searchQuery, onSearchChange, resultsCount }: SearchBarProps) {
  return (
    <div className="glass rounded-xl md:rounded-2xl p-4 md:p-6">
      <div className="relative">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search Your Flights..."
          aria-label="Search flights"
          className="w-full bg-white/5 border border-white/10 rounded-lg pl-3 pr-10 py-2.5 md:py-3 text-sm md:text-base text-white placeholder-white/40 focus:outline-none focus:border-primary-500 focus:bg-white/10 transition-all"
        />
        {searchQuery && (
          <button
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-white/50 hover:text-white transition-colors"
            title="Clear search"
          >
            <X className="w-4 h-4 md:w-5 md:h-5" />
          </button>
        )}
      </div>
      {searchQuery && resultsCount !== undefined && (
        <div className="mt-2 text-xs md:text-sm text-white/60">
          {resultsCount === 0 ? 'No flights found' : `${resultsCount} flight${resultsCount === 1 ? '' : 's'} found`}
        </div>
      )}
    </div>
  );
}
